import "../scss/main/default.scss";

// 모바일 내비 (햄버거) — 메뉴·검색·언어가 한 패널에 들어간다
document.addEventListener("click", (e) => {
  const btn = e.target.closest("[data-nav-toggle]");
  if (!btn) return;
  const menu = document.querySelector("[data-nav-menu]");
  if (!menu) return;
  btn.setAttribute("aria-expanded", menu.classList.toggle("open") ? "true" : "false");
});

// 가로 스크롤 껍데기들의 상태 재판정 함수 모음 (아래에서 채운다).
// 탭이 열리기 전엔 패널이 display:none 이라 폭이 0 이다 — 열린 뒤에 다시 재야 한다.
const sxSyncs = [];

// 탭 전환 (서버 렌더 페이지 위 최소 JS)
const selectTab = (tab) => {
  const group = tab.closest(".f1-tabs");
  if (!group) return;
  group.querySelectorAll("[data-tab]").forEach((t) => t.classList.toggle("active", t === tab));
  // 패널은 이 탭 그룹의 형제만 건드린다 — 안 그러면 중첩 탭(세션별 하위 탭)이 부모 패널을 닫는다.
  // 모바일에선 탭 줄이 제 부모 밖으로 옮겨질 수 있어(hoistSubToggles) 처음 부모를 기억해 쓴다.
  (group.panelHost || group.parentElement).querySelectorAll(":scope > .tab-panel").forEach((p) => {
    p.classList.toggle("active", p.dataset.panel === tab.dataset.tab);
  });
  // 모바일 토글 버튼은 지금 열린 탭을 그대로 비춘다 — 정본은 언제나 .active 버튼
  if (group.tabToggle) syncToggle(group);
  if (group.tabRow) hoistSubToggles(group);
  // 지연 로딩 패널이면 이때 내용을 가져온다
  loadLazyPanel(group);
  // 방금 열린 패널 안의 표가 이제야 폭을 갖는다 — 스크롤 표시를 다시 판정한다
  sxSyncs.forEach((f) => f());
};

// 무거운 탭(레이스 컨트롤·타이어 사용)은 HTML 에 껍데기만 있고 누를 때 받아온다 —
// 다 실으면 레이스 페이지가 1MB 다. 받아온 뒤에는 평소와 똑같이 동작한다.
// 실패하면 껍데기에 링크를 남긴다: 자바스크립트가 죽어도 그 주소로 가면 내용이 나온다.
const loadLazyPanel = (group) => {
  const host = group.panelHost || group.parentElement;
  const panel = [...host.children].find(
    (p) => p.classList.contains("tab-panel") && p.classList.contains("active") && p.dataset.lazy,
  );
  if (!panel || panel.dataset.loading) return;
  panel.dataset.loading = "1";
  panel.innerHTML =
    '<div class="lazy-wait"><span class="lazy-spin"></span>' + (panel.dataset.waitText || "") + "</div>";

  fetch(panel.dataset.lazy, { headers: { "X-Requested-With": "fetch" } })
    .then((r) => (r.ok ? r.text() : Promise.reject(r.status)))
    .then((html) => {
      // 받아온 조각도 tab-panel 껍데기를 갖고 있다 — 안쪽만 꺼내 쓴다
      const tmp = document.createElement("div");
      tmp.innerHTML = html;
      const inner = tmp.querySelector(".tab-panel");
      panel.innerHTML = inner ? inner.innerHTML : html;
      delete panel.dataset.lazy;
      initLazyContent(panel);
    })
    .catch(() => {
      delete panel.dataset.loading;
      panel.innerHTML =
        '<div class="lazy-wait"><a href="' + panel.dataset.lazy.replace("/p/", "/") + '">' +
        (panel.dataset.failText || "") + "</a></div>";
    });
};

// 새로 들어온 조각에도 스크롤 껍데기·하위 탭이 필요하다
const initLazyContent = (panel) => {
  panel.querySelectorAll(".scroll-x, .trace-scroll, .rg-wrap, .slope-scroll").forEach(wrapScrollShell);
  panel.querySelectorAll(".f1-tabs").forEach(setupTabGroup);
  sxSyncs.forEach((f) => f());
  applyFiltersFromHash();
};

// 접힌 버튼의 얼굴 = 지금 열린 탭.
// 갱신 점은 **지금 열린 탭**의 것만 보여준다. 처음엔 "갱신된 탭이 어딘가 있다"는
// 뜻으로 한 번만 켜 뒀는데, 점 없는 탭을 골라도 점이 남아 있어 이 탭이 갱신된
// 것처럼 읽혔다. 어느 탭이 갱신됐는지는 펼치면 목록에서 그대로 보인다.
//
// 라벨에서 점을 떼는 건 그대로 — 버튼 오른쪽에 이미 점 자리가 있어서,
// 한 줄에 빨간 점이 둘이면 무슨 뜻인지 알 수 없다.
const syncToggle = (group) => {
  const btn = group.tabToggle;
  const act = group.querySelector("[data-tab].active") || group.querySelector("[data-tab]");
  const label = btn.querySelector(".tab-dd-label");
  label.innerHTML = act ? act.innerHTML : "";
  label.querySelectorAll(".tab-new").forEach((d) => d.remove());
  btn.classList.toggle("has-new", !!(act && act.querySelector(".tab-new")));
  group.classList.remove("open");
  btn.setAttribute("aria-expanded", "false");
};

// 열린 패널의 하위 탭을 상위 토글 옆으로 끌어올린다 —
// [레이스 컨트롤 ▾] [예선 48 ▾] 처럼 한 줄에 서야 상하위 관계가 읽히고 한 줄을 아낀다.
// 토글만 옮기면 목록은 패널에 남아 엉뚱한 데서 펼쳐지므로 탭 줄까지 같이 옮긴다.
// 원래 자리에는 빈 표식(.tab-dd-home)을 남겨 두고, 되돌릴 때 그 뒤에 다시 끼운다.
//
// 화면 폭은 보지 않는다. 줄(.tab-dd-row)이 상위 탭 줄까지 품고 있어서 DOM 순서가
//   [상위 토글][상위 탭 줄][하위 토글][하위 탭 줄]
// 이 되고, 넓은 화면에서는 토글이 숨은 채 탭 줄 둘만 원래 순서대로 쌓인다.
// 미디어 쿼리 이벤트에 기대면 그게 안 올 때 하위 탭 줄이 상위 위로 올라가 버린다.
const hoistSubToggles = (root) => {
  // 먼저 올라와 있는 것들을 전부 제자리로 되돌린다
  [...root.tabRow.querySelectorAll(".tab-dd-toggle.lv2")].forEach((b) => {
    b.tabHome.after(b, b.tabGroup);
  });
  const panel = [...root.panelHost.children]
    .find((p) => p.classList.contains("tab-panel") && p.classList.contains("active"));
  if (!panel) return;
  panel.querySelectorAll(":scope > .tab-dd-toggle").forEach((b) => {
    root.tabRow.append(b, b.tabGroup);
  });
};

// 모바일: 탭 줄이 화면 밖으로 3배 넘게 흘러도(레이스 1단 탭 15개 = 1104px) 가로로
// 스크롤된다는 걸 알 방법이 없다. 접었다 펴는 버튼을 앞에 세운다.
//
// <select> 로 만들면 <option> 이 글자만 담는 탓에 '갱신됨' 빨간 점이 죽는다.
// 그래서 목록은 원래 탭 버튼 그대로 쓴다 — 마크업이 하나뿐이라 점도, 해시 링크도,
// JS 없는 환경도 손댈 필요가 없다.
//
// 단계별로 다른 컨트롤을 준다. 같은 생김새면 상위 탭을 고른 건지 하위 탭을 고른 건지
// 알 수 없다 — 1단은 큰 버튼, 2단은 눌러둔 작은 버튼.
const setupTabGroup = (group) => {
  const tabs = [...group.querySelectorAll("[data-tab]")];
  if (tabs.length < 2) return;   // 필터 칩 줄(data-tab 없음)과 단일 탭은 대상이 아니다

  let depth = 0;
  for (let p = group.parentElement; p; p = p.parentElement) {
    if (p.classList.contains("tab-panel")) depth++;
  }

  const btn = document.createElement("button");
  btn.type = "button";
  btn.className = "tab-dd-toggle lv" + (depth > 0 ? 2 : 1);
  btn.setAttribute("aria-expanded", "false");
  btn.innerHTML = '<span class="tab-dd-label"></span><span class="tab-dd-caret"></span>';

  btn.addEventListener("click", () => {
    const open = group.classList.toggle("open");
    btn.setAttribute("aria-expanded", open ? "true" : "false");
  });

  group.tabToggle = btn;
  group.panelHost = group.parentElement;   // 옮겨져도 패널은 여기서 찾는다
  btn.tabGroup = group;

  group.classList.add("has-dd");   // 좁은 화면에서 이 줄만 접는다 (_layout.scss)
  // 단계를 클래스로 박아 둔다. 하위 탭 줄은 아래에서 패널 밖으로 옮겨지므로
  // '.tab-panel 안에 있으면 하위'라는 위치 기반 선택자로는 모양이 풀린다.
  group.classList.add(depth > 0 ? "lv2" : "lv1");

  if (depth > 0) {
    // 되돌아올 자리 표식 — 끌어올려지는 건 하위 탭뿐이라 상위에는 두지 않는다.
    // 상위에도 두면 앞 블록과 줄 사이에 끼어, 위 여백을 줄이는 :has 규칙이
    // 정작 여백을 든 블록 대신 이 표식을 집는다.
    const home = document.createElement("span");
    home.className = "tab-dd-home";
    btn.tabHome = home;
    group.before(home, btn);
  } else {
    group.before(btn);
  }

  // 1단은 자기 토글·탭 줄과 끌어올린 하위 탭을 같이 담을 줄을 갖는다.
  // 탭 줄까지 넣어야 넓은 화면에서 하위 탭 줄이 상위 탭 줄 **아래**에 놓인다.
  if (depth === 0) {
    const row = document.createElement("div");
    row.className = "tab-dd-row";
    btn.before(row);
    row.append(btn, group);
    group.tabRow = row;
  }

  syncToggle(group);
};

document.querySelectorAll(".f1-tabs").forEach(setupTabGroup);

// 처음 열려 있는 패널의 하위 탭도 올려둔다 (탭을 눌러야 올라가면 늦다)
document.querySelectorAll(".f1-tabs").forEach((g) => { if (g.tabRow) hoistSubToggles(g); });

// 가로 스크롤 영역에 "더 있다" 표시 —
// 표·차트가 화면보다 넓을 때 오른쪽이 잘린 건지 밀 수 있는 건지 알 수가 없었다.
// 더 밀 데가 있는 쪽 가장자리에 페이드를 덮는다. 끝에 닿으면 그쪽은 꺼지므로
// 어디까지 왔는지도 같이 읽힌다.
//
// 페이드는 내용 위에 와야 한다 — 스크롤 상자의 배경으로 깔면 불투명한 셀·막대
// 밑에 묻힌다. 그래서 상자를 껍데기로 감싸고 껍데기에 그린다.
const wrapScrollShell = (sc) => {
    if (sc.parentElement && sc.parentElement.classList.contains("sx-shell")) return;
    const shell = document.createElement("div");
    shell.className = "sx-shell";
    sc.before(shell);
    shell.append(sc);

    const sync = () => {
      const max = sc.scrollWidth - sc.clientWidth;
      // 1px 어긋남(소수점 폭·확대)에 페이드가 깜빡이지 않게 여유를 둔다
      shell.classList.toggle("sx-l", sc.scrollLeft > 2);
      shell.classList.toggle("sx-r", max > 2 && sc.scrollLeft < max - 2);
      // 표보다 좁은 '보이는 폭'을 아래로 내려준다 — 표 안에 있으면서도 화면 폭에
      // 맞춰 접혀야 하는 조각(페널티 사유 줄)이 이 값을 쓴다.
      // clientWidth 는 패딩을 포함한다. 스크롤 상자가 패딩 있는 카드면(.f1-card.pad)
      // 그만큼 넓게 잡혀 표를 밀어내고, 표가 다 들어오는데도 가로 스크롤이 생긴다.
      const cs = getComputedStyle(sc);
      const inner = sc.clientWidth - parseFloat(cs.paddingLeft) - parseFloat(cs.paddingRight);
      shell.style.setProperty("--sx-w", inner + "px");
    };
    sc.addEventListener("scroll", sync, { passive: true });
    if (window.ResizeObserver) new ResizeObserver(sync).observe(sc);
    sxSyncs.push(sync);
    sync();
};

document.querySelectorAll(".scroll-x, .trace-scroll, .ws-wrap, .career-scroll, .rg-wrap, .slope-scroll")
  .forEach(wrapScrollShell);

// 창 크기가 바뀌면 다시 판정한다 — 폭이 넓어져 표가 다 들어오면 페이드도 꺼져야 한다.
// ResizeObserver 만으로는 뷰포트 변화를 놓치는 경우가 있다.
window.addEventListener("resize", () => sxSyncs.forEach((f) => f()), { passive: true });

// 펼쳐둔 채 딴 데를 누르면 닫는다
document.addEventListener("click", (e) => {
  document.querySelectorAll(".f1-tabs.open").forEach((g) => {
    if (g.contains(e.target) || g.tabToggle.contains(e.target)) return;
    g.classList.remove("open");
    g.tabToggle.setAttribute("aria-expanded", "false");
  });
});

// 주소 해시는 탭 하나만 담았었다. 필터도 담아야 링크를 복사해 주면 상대가 같은
// 화면을 본다 — "#rc&doc=SC" 처럼 & 로 잇고, 값이 없는 조각을 탭으로 본다.
// (기존 "#rc" 링크가 그대로 동작해야 해서 탭에는 키를 붙이지 않는다)
const hashParts = () => location.hash.slice(1).split("&").filter(Boolean);
const hashTab = () => decodeURIComponent(hashParts().find((p) => !p.includes("=")) || "");
const hashFilters = () => Object.fromEntries(hashParts().filter((p) => p.includes("="))
  .map((p) => [decodeURIComponent(p.slice(0, p.indexOf("="))), decodeURIComponent(p.slice(p.indexOf("=") + 1))]));
const writeHash = (tab, filters) => {
  const parts = tab ? [encodeURIComponent(tab)] : [];
  Object.entries(filters).forEach(([k, v]) => {
    if (v) parts.push(encodeURIComponent(k) + "=" + encodeURIComponent(v));
  });
  // pushState 가 아니라 replaceState — 탭·필터를 누를 때마다 뒤로가기가 쌓이면 성가시다
  try {
    history.replaceState(null, "", parts.length ? "#" + parts.join("&") : location.pathname + location.search);
  } catch (err) { /* file:// 등 */ }
};
// 필터 줄은 data-fkey 로 자기 이름을 들고 있다(같은 화면에 필터가 둘 이상이라)
const setHashFilter = (row, val) => {
  const key = row?.dataset.fkey;
  if (!key) return;
  writeHash(hashTab(), { ...hashFilters(), [key]: val });
};

document.addEventListener("click", (e) => {
  const tab = e.target.closest("[data-tab]");
  if (!tab) return;
  e.preventDefault();
  selectTab(tab);
  // 탭을 바꿔도 걸어둔 필터는 주소에 그대로 남긴다
  writeHash(tab.dataset.tab, hashFilters());
});

// #race 처럼 해시로 들어오면 그 탭을 연다. 대소문자는 가리지 않는다(#Race 도 동작).
// 하위 탭(#sg-sprint 등)이면 그 조상 탭까지 거슬러 올라가며 함께 연다.
// 해시에 담겨 온 필터를 눌러준다. 값을 직접 적용하지 않고 버튼을 클릭하는 이유는
// 필터마다 하는 일이 달라서다 — 누르는 순간부터는 평소 경로와 완전히 같다.
const applyFiltersFromHash = () => {
  const want = hashFilters();
  document.querySelectorAll("[data-fkey]").forEach((row) => {
    const val = want[row.dataset.fkey];
    if (val === undefined) return;
    const btn = [...row.querySelectorAll("[data-cf], [data-rcf]")]
      .find((b) => (b.dataset.cf ?? b.dataset.rcf) === val);
    if (btn) btn.click();
  });
};

const openTabFromHash = () => {
  const key = hashTab().toLowerCase();
  if (!key) return;
  const tab = [...document.querySelectorAll("[data-tab]")]
    .find((t) => (t.dataset.tab || "").toLowerCase() === key);
  if (!tab) return;

  // 하위 탭이면 그 탭을 품은 패널의 부모 탭까지 거슬러 올라간다.
  // 여는 순서는 바깥 -> 안쪽이어야 한다. 안쪽을 먼저 열면 바깥 탭을 전환하는 순간
  // 그 그룹의 패널이 전부 닫히면서 방금 연 하위 탭이 같이 숨는다.
  const chain = [];
  for (let cur = tab; cur && !chain.includes(cur); ) {
    chain.unshift(cur);
    const panel = cur.closest(".tab-panel");
    if (!panel) break;
    cur = document.querySelector('[data-tab="' + panel.dataset.panel + '"]');
  }
  chain.forEach(selectTab);
  chain[0].closest(".f1-tabs")?.scrollIntoView({ block: "start", behavior: "smooth" });
};
openTabFromHash();
window.addEventListener("hashchange", () => { openTabFromHash(); applyFiltersFromHash(); });

// 연도 셀렉트 등 — 선택 시 해당 URL로 이동
document.addEventListener("change", (e) => {
  const sel = e.target.closest("select[data-nav]");
  if (sel) location.href = sel.value;
});

// 드라이버 비교 — 검색형 콤보박스 2개를 -vs- URL로 조합
document.querySelectorAll("[data-cmp]").forEach((root) => {
  const drivers = JSON.parse(root.querySelector("[data-cmp-data]").textContent);
  const boxes = root.querySelectorAll("[data-cmp-box]");

  boxes.forEach((box) => {
    const input = box.querySelector("[data-cmp-input]");
    const slug = box.querySelector("[data-cmp-slug]");
    const list = box.querySelector("[data-cmp-listbox]");

    const render = (q) => {
      const query = q.trim().toLowerCase();
      const hits = drivers
        .filter((d) => !query || d.q.includes(query))
        .slice(0, 8);
      list.innerHTML = hits
        .map((d) => `<li data-slug="${d.slug}">${d.name}</li>`)
        .join("");
      list.style.display = hits.length ? "block" : "none";
    };

    input.addEventListener("focus", () => render(input.value));
    input.addEventListener("input", () => {
      slug.value = ""; // 타이핑 중이면 선택 무효
      render(input.value);
    });
    list.addEventListener("mousedown", (e) => {
      const li = e.target.closest("li");
      if (!li) return;
      e.preventDefault();
      slug.value = li.dataset.slug;
      input.value = li.textContent;
      list.style.display = "none";
    });
    input.addEventListener("blur", () => setTimeout(() => (list.style.display = "none"), 150));
  });

  root.querySelector("[data-cmp-go]").addEventListener("click", (e) => {
    e.preventDefault();
    const [a, b] = [...boxes].map((x) => x.querySelector("[data-cmp-slug]").value);
    if (!a || !b) {
      alert(document.documentElement.lang === "ko" ? "두 드라이버를 모두 검색해 선택하세요." : "Search and pick both drivers.");
      return;
    }
    if (a === b) return;
    location.href = "/compare/" + a + "-vs-" + b;
  });
});

// 히어로 카운트다운 (data-countdown="ISO시각", data-cd="d|h|m" 셀 갱신)
document.querySelectorAll("[data-countdown]").forEach((el) => {
  const target = new Date(el.dataset.countdown).getTime();
  if (isNaN(target)) return;
  const cell = (k) => el.querySelector(`[data-cd="${k}"]`);
  const pad = (n) => String(n).padStart(2, "0");
  const tick = () => {
    const diff = Math.max(0, target - Date.now());
    const mins = Math.floor(diff / 60000);
    cell("d").textContent = pad(Math.floor(mins / 1440));
    cell("h").textContent = pad(Math.floor((mins % 1440) / 60));
    cell("m").textContent = pad(mins % 60);
  };
  tick();
  setInterval(tick, 15000);
});

// 서킷 3D 레이아웃 — 등축 투영 SVG, 드래그 회전 + 섹터/코너/방향 토글 (외부 의존성 없음)
document.querySelectorAll("[data-track3d]").forEach((el) => {
  const pts = JSON.parse(el.dataset.track3d);
  // OpenF1 y는 북쪽이 +, 화면 y는 아래가 + — 반전하지 않으면 트랙이 좌우 거울상이 된다
  pts.forEach((p) => { p[1] = -p[1]; });
  const meta = JSON.parse(el.dataset.trackMeta || "{}");
  const zExaggerate = parseFloat(el.dataset.zScale || "4"); // 트랙은 평평해서 고도를 과장해야 보인다
  const mini = el.dataset.trackUi === "off"; // 간략 모드: 라인+S/F만, 토글·정보·프로필 없음
  const W = 720, H = 420;
  const NS = "http://www.w3.org/2000/svg";
  const mk = (tag, attrs) => {
    const n = document.createElementNS(NS, tag);
    for (const k in attrs) n.setAttribute(k, attrs[k]);
    return n;
  };

  // ---- 파생 정보 (전부 좌표에서 계산)
  // 방향: 슈레이스 면적 부호 (화면 좌표 기준)
  let area = 0;
  for (let i = 0; i < pts.length; i++) {
    const [x1, y1] = pts[i], [x2, y2] = pts[(i + 1) % pts.length];
    area += x1 * y2 - x2 * y1;
  }
  const clockwise = area > 0; // OpenF1 좌표계 기준 보정

  // 코너 번호·이름 표시는 제거됨 — 곡률 자동 감지가 실제 공식 코너와 자주 어긋났다.
  // 정확한 코너 데이터(공식 번호·명칭) 확보 전까지는 표시하지 않는다.

  // ---- SVG 골격
  const svg = mk("svg", { viewBox: `0 0 ${W} ${H}` });
  svg.style.cssText = "width:100%;height:auto;display:block;cursor:grab;touch-action:none";
  const shadow = mk("path", { fill: "none", stroke: "var(--hairline)", "stroke-width": "1" });
  const line = mk("path", { fill: "none", stroke: "var(--ink)", "stroke-width": "4", "stroke-linecap": "round", "stroke-linejoin": "round" });
  // 섹터 모드: F1 관례색 구간 라인 (S1 빨강 / S2 파랑 / S3 노랑)
  const SECTOR_COLORS = ["var(--error)", "var(--link)", "var(--warning)"];
  const sectorPaths = SECTOR_COLORS.map((c) =>
    mk("path", { fill: "none", stroke: c, "stroke-width": "5", "stroke-linecap": "round", "stroke-linejoin": "round" }));
  const overlay = mk("g", {});
  const start = mk("circle", { r: "4", fill: "var(--link)" });
  svg.append(shadow, line, ...sectorPaths, overlay, start);
  el.appendChild(svg);

  // 화면 채우기: 내접원(maxR) 기준 대신, 어느 각도로 돌려도 잘리지 않는
  // 최대 지름(D) 기준으로 스케일 — 여백이 절반 이하로 준다. 라벨 여유만 패딩.
  let mode3d = !mini; // 3D 사선 투영 ↔ 2D 탑다운 (미니 맵은 2D 고정)
  let pitch = mini ? 1 : 0.42;
  let D = 0, di = 0, dj = 0;
  for (let i = 0; i < pts.length; i += 3) {
    for (let j = i + 3; j < pts.length; j += 3) {
      const dx = pts[i][0] - pts[j][0], dy = pts[i][1] - pts[j][1];
      const dd = dx * dx + dy * dy;
      if (dd > D) { D = dd; di = i; dj = j; }
    }
  }
  D = Math.sqrt(D) || 1;
  const zs = pts.map((p) => p[2] || 0);
  const zLo = Math.min(...zs), zHi = Math.max(...zs);
  const zMid = (zHi + zLo) / 2;
  const zSpan = (zHi - zLo) * zExaggerate;
  // 초기 각도: 트랙 장축이 수평이 되게 — 로드 직후부터 화면을 넓게 쓴다
  let yaw = -Math.atan2(pts[dj][1] - pts[di][1], pts[dj][0] - pts[di][0]);
  const show = { sector: false, dir: true };

  // 현재 각도의 실제 투영 폭·높이 (pitch·고도 반영, 스케일 전 단위)
  const extents = () => {
    const c = Math.cos(yaw), sn = Math.sin(yaw);
    let x1 = Infinity, x2 = -Infinity, y1 = Infinity, y2 = -Infinity;
    for (let i = 0; i < pts.length; i += 2) {
      const rx = pts[i][0] * c - pts[i][1] * sn;
      const ry = (pts[i][0] * sn + pts[i][1] * c) * pitch - (pts[i][2] || 0) * (mode3d ? zExaggerate : 0);
      if (rx < x1) x1 = rx; if (rx > x2) x2 = rx;
      if (ry < y1) y1 = ry; if (ry > y2) y2 = ry;
    }
    return [x2 - x1, y2 - y1];
  };

  // viewBox 높이: 기본 각도에서 가로를 채웠을 때 실제로 필요한 만큼만
  const ext0 = extents();
  const s0 = (W - 90) / ext0[0];
  const VH = Math.max(220, Math.min(H, Math.round(ext0[1] * s0 + 76)));
  svg.setAttribute("viewBox", `0 0 ${W} ${VH}`);

  // 각도별 맞춤 스케일 — 회전하면 그 각도에서 화면을 최대로 쓰도록 재계산
  let scale = s0;
  const fitScale = () => {
    const [xe, ye] = extents();
    scale = Math.min((W - 90) / xe, (VH - 64) / ye);
  };
  fitScale();

  const project = ([x, y, z], flat) => {
    const c = Math.cos(yaw), s = Math.sin(yaw);
    const rx = x * c - y * s;
    const ry = x * s + y * c;
    const pz = (flat || !mode3d) ? 0 : z * zExaggerate;
    return [W / 2 + rx * scale, VH / 2 + (mode3d ? (zMid * zExaggerate * scale) / 2 : 0) + ry * scale * pitch - pz * scale];
  };
  const toPath = (flat) =>
    pts.map((p, i) => (i ? "L" : "M") + project(p, flat).map((v) => v.toFixed(1)).join(" ")).join("") + "Z";
  const label = (x, y, text, size, color) => {
    const t = mk("text", { x, y, "font-size": size, fill: color, "text-anchor": "middle", "font-family": "var(--font-mono)" });
    t.textContent = text;
    return t;
  };
  // 트랙 바깥쪽으로 라벨을 밀어내는 법선
  const outward = (i, dist) => {
    const [px, py] = project(pts[i], false);
    const [ax, ay] = project(pts[(i + pts.length - 3) % pts.length], false);
    const [bx, by] = project(pts[(i + 3) % pts.length], false);
    let nx = -(by - ay), ny = bx - ax;
    const len = Math.hypot(nx, ny) || 1;
    nx /= len; ny /= len;
    const [cx0, cy0] = project([0, 0, 0], true);
    if ((px + nx * dist - cx0) ** 2 + (py + ny * dist - cy0) ** 2 < (px - nx * dist - cx0) ** 2 + (py - ny * dist - cy0) ** 2) { nx = -nx; ny = -ny; }
    return [px + nx * dist, py + ny * dist, px, py];
  };

  const segPath = (from, to) => {
    let d = "";
    for (let i = from; ; i++) {
      const idx = i % pts.length;
      d += (d ? "L" : "M") + project(pts[idx], false).map((v) => v.toFixed(1)).join(" ");
      if (idx === to % pts.length) break;
    }
    return d;
  };

  const render = () => {
    fitScale();
    shadow.setAttribute("d", mode3d ? toPath(true) : ""); // 2D에선 그림자=본선이라 숨김
    const [sx, sy] = project(pts[0], false);
    start.setAttribute("cx", sx);
    start.setAttribute("cy", sy);
    overlay.innerHTML = "";

    // 섹터: 트랙 라인을 S1/S2/S3 색 구간으로
    const hasSectors = meta.sector_breaks && meta.sector_breaks.length === 2;
    if (show.sector && hasSectors) {
      const [b1, b2] = meta.sector_breaks;
      line.setAttribute("d", "");
      [[0, b1], [b1, b2], [b2, pts.length]].forEach(([f, t], n) => {
        sectorPaths[n].setAttribute("d", segPath(f, t));
        const mid = Math.floor((f + t) / 2) % pts.length;
        const [lx, ly] = outward(mid, 18);
        overlay.appendChild(label(lx, ly + 3, "S" + (n + 1), 11, SECTOR_COLORS[n]));
      });
    } else {
      sectorPaths.forEach((p) => p.setAttribute("d", ""));
      line.setAttribute("d", toPath(false));
    }

    // S/F 라벨
    overlay.appendChild(label(sx, sy - 10, "S/F", 10, "var(--link)"));

    // 진행 방향 화살표 — 스타트 직후
    if (show.dir) {
      const i = 6;
      const [x1, y1] = project(pts[i], false);
      const [x2, y2] = project(pts[(i + 4) % pts.length], false);
      const a = Math.atan2(y2 - y1, x2 - x1);
      const s = mini ? 16 : 12;
      const p1 = [x2, y2];
      const p2 = [x2 - s * Math.cos(a - 0.5), y2 - s * Math.sin(a - 0.5)];
      const p3 = [x2 - s * Math.cos(a + 0.5), y2 - s * Math.sin(a + 0.5)];
      // 굵은 트랙선 위에서 묻히지 않게 흰 테두리를 두른다
      overlay.appendChild(mk("path", {
        d: `M${p1} L${p2} L${p3}Z`,
        fill: "var(--ink)",
        stroke: "var(--canvas-elevated)",
        "stroke-width": "2",
        "stroke-linejoin": "round",
      }));
    }
  };
  render();

  // ---- 토글 버튼
  if (!mini) {
  const bar = document.createElement("div");
  bar.style.cssText = "display:flex;gap:6px;justify-content:flex-end;padding:0 8px 4px";
  // 2D/3D 토글
  const mb = document.createElement("button");
  mb.textContent = "2D";
  mb.className = "badge ghost";
  mb.style.cssText = "cursor:pointer;border:1px solid var(--hairline)";
  mb.onclick = () => {
    mode3d = !mode3d;
    pitch = mode3d ? 0.42 : 1;
    mb.className = "badge " + (mode3d ? "ghost" : "ink");
    render();
  };
  bar.appendChild(mb);
  (document.documentElement.lang === "ko" ? [["sector", "섹터"], ["dir", "방향"]] : [["sector", "Sectors"], ["dir", "Direction"]]).forEach(([key, name]) => {
    const b = document.createElement("button");
    b.textContent = name;
    b.className = "badge " + (show[key] ? "ink" : "ghost");
    b.style.cssText = "cursor:pointer;border:1px solid var(--hairline)";
    b.onclick = () => { show[key] = !show[key]; b.className = "badge " + (show[key] ? "ink" : "ghost"); render(); };
    bar.appendChild(b);
  });
  el.prepend(bar);
  }

  // 메타 라인(길이·방향)
  if (el.dataset.trackInfo === "on" || (!mini && el.dataset.trackInfo !== "off")) {
    const info = document.createElement("div");
    info.style.cssText = "font:var(--type-body-sm) ;color:var(--faint);padding:0 8px 8px;text-align:right";
    info.textContent = (meta.length_km ? (document.documentElement.lang === "ko" ? "길이 ≈" : "length ≈") + meta.length_km + "km · " : "")
      + (document.documentElement.lang === "ko" ? (clockwise ? "시계 방향" : "반시계 방향") : (clockwise ? "clockwise" : "anti-clockwise"));
    el.appendChild(info);
  }

  // ---- 인터랙션 (미니 맵은 정지 — S/F 위치가 늘 같은 자리에 보인다)
  if (mini) {
    svg.style.cursor = "default";
  } else {
  let auto = setInterval(() => { yaw += 0.004; render(); }, 40);
  let dragging = false, lastX = 0;
  const stopAuto = () => { if (auto) { clearInterval(auto); auto = null; } };
  svg.addEventListener("pointerdown", (e) => {
    stopAuto(); dragging = true; lastX = e.clientX;
    svg.style.cursor = "grabbing"; svg.setPointerCapture(e.pointerId);
  });
  svg.addEventListener("pointermove", (e) => {
    if (!dragging) return;
    yaw += (e.clientX - lastX) * 0.008;
    lastX = e.clientX;
    render();
  });
  svg.addEventListener("pointerup", () => { dragging = false; svg.style.cursor = "grab"; });
  }

  // ---- 고도 프로필 (랩 거리 대비 고도)
  if (!mini) {
  const pw = 720, ph = 64;
  const dist = [0];
  for (let i = 1; i < pts.length; i++) dist.push(dist[i - 1] + Math.hypot(pts[i][0] - pts[i - 1][0], pts[i][1] - pts[i - 1][1]));
  const total = dist[dist.length - 1];
  const zMax = Math.max(...pts.map((p) => p[2])) || 1;
  const prof = mk("svg", { viewBox: `0 0 ${pw} ${ph}` });
  prof.style.cssText = "width:100%;height:auto;display:block;margin-top:4px";
  const py = (z) => ph - 12 - (z / zMax) * (ph - 24);
  const d = pts.map((p, i) => (i ? "L" : "M") + (dist[i] / total * pw).toFixed(1) + " " + py(p[2]).toFixed(1)).join("");
  prof.appendChild(mk("line", { x1: 0, y1: ph - 12, x2: pw, y2: ph - 12, stroke: "var(--hairline)", "stroke-width": "1" }));
  prof.appendChild(mk("path", { d, fill: "none", stroke: "var(--mute)", "stroke-width": "1.5" }));
  const peakI = pts.findIndex((p) => p[2] === zMax);
  const peakT = label(Math.min(pw - 30, Math.max(30, dist[peakI] / total * pw)), py(zMax) - 4, "+" + (zMax / 10).toFixed(0) + "m", 9, "var(--faint)");
  prof.appendChild(peakT);
  const profWrap = document.createElement("div");
  profWrap.style.cssText = "padding:0 8px";
  const profLabel = document.createElement("div");
  profLabel.className = "eyebrow";
  profLabel.style.cssText = "padding:8px 0 0";
  profLabel.textContent = "Elevation Profile";
  profWrap.append(profLabel, prof);
  el.appendChild(profWrap);
  }
});

// 시각 로컬라이즈 — 서버는 KST 폴백을 렌더하고, JS가 접속자 시간대·언어로 다시 쓴다
// [data-lt="UTC ISO"] + data-fmt(time|d-time|md|md-time|mdd-time), [data-tz] = 시간대 약칭
(() => {
  const lang = document.documentElement.lang || "en";
  const locale = { ko: "ko-KR", en: "en-GB", es: "es-ES", pt: "pt-BR", de: "de-DE", fr: "fr-FR", it: "it-IT", nl: "nl-NL", ja: "ja-JP", zh: "zh-CN" }[lang] || "en-GB";
  const pad = (n) => String(n).padStart(2, "0");
  const wd = (d) => { try { return "(" + d.toLocaleDateString(locale, { weekday: "short" }) + ")"; } catch (e) { return ""; } };

  let tz = "";
  try {
    tz = new Intl.DateTimeFormat(locale, { timeZoneName: "short" })
      .formatToParts(new Date()).find((p) => p.type === "timeZoneName").value;
  } catch (e) { /* 미지원 브라우저는 KST 폴백 유지 */ }
  if (tz) document.querySelectorAll("[data-tz]").forEach((el) => { el.textContent = tz; });

  document.querySelectorAll("[data-lt]").forEach((el) => {
    const d = new Date(el.dataset.lt);
    if (isNaN(d)) return;
    const time = pad(d.getHours()) + ":" + pad(d.getMinutes());
    let md;
    try { md = d.toLocaleDateString(locale, { month: "short", day: "numeric" }) + " " + wd(d); } catch (e) { md = (d.getMonth() + 1) + "/" + d.getDate(); }
    const dayUnit = lang === "ko" ? "일 " : (lang === "ja" || lang === "zh") ? "日 " : " ";
    const map = {
      "time": time,
      "md": md,
      "md-time": md + " " + time,
      "d-time": d.getDate() + dayUnit + wd(d) + " " + time,
      "mdd-time": pad(d.getMonth() + 1) + "." + pad(d.getDate()) + " " + wd(d) + " " + time,
    };
    el.textContent = map[el.dataset.fmt || "md-time"] || map["md-time"];
  });
})();

// 기록 카드 필터·검색 (button[data-cf] + input[data-cardsearch] → [data-cards] [data-g])
const applyRecordCards = () => {
  const wrap = document.querySelector("[data-cards]");
  if (!wrap) return;
  const active = document.querySelector("[data-cardfilter] .active");
  const v = active ? active.dataset.cf : "";
  const q = (document.querySelector("[data-cardsearch]")?.value || "").trim().toLowerCase();
  wrap.querySelectorAll("[data-g]").forEach((c) => {
    const okG = !v || c.dataset.g === v;
    const okQ = !q || c.textContent.toLowerCase().includes(q);
    c.style.display = okG && okQ ? "" : "none";
  });
};
document.addEventListener("click", (e) => {
  const b = e.target.closest("[data-cf]");
  if (!b) return;
  const row = b.closest("[data-cardfilter]");
  row.querySelectorAll("[data-cf]").forEach((x) => x.classList.toggle("active", x === b));
  applyRecordCards();
  setHashFilter(row, b.dataset.cf);
});
document.addEventListener("input", (e) => {
  if (e.target.closest("[data-cardsearch]")) applyRecordCards();
});

// 분류 필터 (button[data-rcf] → tr[data-rcg]) — data-rc-target으로 대상 테이블 지정
document.addEventListener("click", (e) => {
  const btn = e.target.closest("[data-rcf]");
  if (!btn) return;
  const wrap = btn.closest("[data-rcfilter]");
  // 알약형 필터라 선택 표시는 .on — 탭(.active)과 모양이 갈려야
  // 세션 탭 바로 아래 붙어 있어도 역할이 구분된다
  wrap.querySelectorAll("[data-rcf]").forEach((b) => {
    // 처음 켜둔 표시가 .active 인 줄이 있다(FIA 문서 필터). .on 만 토글하면
    // 다른 값을 눌러도 '전체'가 켜진 채로 남아 둘이 동시에 선택돼 보인다.
    b.classList.remove("active");
    b.classList.toggle("on", b === btn);
  });
  const val = btn.dataset.rcf;
  const target = wrap.dataset.rcTarget ? document.querySelector(wrap.dataset.rcTarget) : document.querySelector("[data-rctable]");
  if (!target) return;
  target.querySelectorAll("tbody tr").forEach((tr) => {
    tr.style.display = !val || tr.dataset.rcg === val ? "" : "none";
  });
  setHashFilter(wrap, val);
});

// 테이블 텍스트 필터 (input[data-filter="#tableId"])
document.addEventListener("input", (e) => {
  const box = e.target.closest("[data-filter]");
  if (!box) return;
  const q = box.value.trim().toLowerCase();
  const table = document.querySelector(box.dataset.filter);
  if (table) table.classList.toggle("filtering", !!q); // 검색 중엔 점진 노출 캡 해제
  document.querySelectorAll(`${box.dataset.filter} tbody tr`).forEach((tr) => {
    // 모바일에서 아래로 내려간 줄(.row-note)은 위 행의 이어짐이다. 따로 판정하면
    // 검색어가 아래 줄에만 있을 때 위 행만 사라져 반쪽짜리 행이 남는다.
    if (tr.classList.contains("row-note")) return;
    const note = tr.nextElementSibling?.classList.contains("row-note") ? tr.nextElementSibling : null;
    const hay = (tr.textContent + " " + (note ? note.textContent : "") + " " + (tr.dataset.alias || "")).toLowerCase();
    tr.style.display = !q || hay.includes(q) ? "" : "none";
    if (note) note.style.display = tr.style.display;
  });
});

// 긴 목록: 앞쪽 N행만 두고 스크롤이 끝에 닿을 때마다 이어서 노출.
// 페이지네이션 대신 — URL이 하나라 검색 필터·SEO·링크가 그대로다.
document.querySelectorAll("table[data-progressive]").forEach((table) => {
  const step = parseInt(table.dataset.progressive, 10) || 40;
  const rows = [...table.querySelectorAll("tbody tr")];
  if (rows.length <= step) return;

  let shown = step;
  const paint = () => rows.forEach((tr, i) => tr.classList.toggle("row-more", i >= shown));
  paint();

  const onScroll = () => {
    const last = rows[shown - 1];
    if (!last || last.getBoundingClientRect().top > window.innerHeight + 400) return;
    shown += step;
    paint();
    if (shown >= rows.length) window.removeEventListener("scroll", onScroll);
  };
  window.addEventListener("scroll", onScroll, { passive: true });
  onScroll(); // 화면이 길면 처음부터 한 번 더 채운다
});

// 즉시 툴팁 — 브라우저 기본 title 은 1초쯤 지나야 뜬다. 차트가 많은 사이트라
// 데이터를 확인하려고 매번 기다리게 된다. 소스는 두 가지를 모두 받는다.
//   HTML: title="..."         SVG: <rect><title>...</title></rect>
// 원본은 data-tip 으로 옮기고 aria-label 을 남겨 접근성은 유지한다.
(() => {
  let tip = null;
  const show = (text, x, y) => {
    if (!tip) {
      tip = document.createElement("div");
      tip.className = "tip";
      document.body.appendChild(tip);
    }
    tip.textContent = text;
    tip.style.display = "block";
    const r = tip.getBoundingClientRect();
    const pad = 12;
    let left = x + 14;
    let top = y + 16;
    if (left + r.width > innerWidth - pad) left = x - r.width - 14;
    if (top + r.height > innerHeight - pad) top = y - r.height - 12;
    tip.style.left = Math.max(pad, left) + "px";
    tip.style.top = Math.max(pad, top) + "px";
  };
  const hide = () => { if (tip) tip.style.display = "none"; };

  // 대상 요소에서 툴팁 문구를 꺼내고, 기본 툴팁이 뒤늦게 겹쳐 뜨지 않게 원본을 걷어낸다
  const grab = (el) => {
    if (el.dataset && el.dataset.tip !== undefined) return el.dataset.tip;
    const attr = el.getAttribute && el.getAttribute("title");
    if (attr) {
      el.removeAttribute("title");
      el.setAttribute("aria-label", attr);
      el.dataset.tip = attr;
      return attr;
    }
    // SVG 도형은 자식 <title> 을 쓴다
    const child = el.querySelector && el.querySelector(":scope > title");
    if (child) {
      const t = child.textContent.trim();
      child.remove();
      el.setAttribute("aria-label", t);
      if (el.dataset) el.dataset.tip = t;
      else el.setAttribute("data-tip", t);
      return t;
    }
    return null;
  };

  document.addEventListener("mousemove", (e) => {
    let el = e.target;
    for (let i = 0; el && i < 4; i++, el = el.parentElement) {
      const t = grab(el);
      if (t) { show(t, e.clientX, e.clientY); return; }
    }
    hide();
  }, { passive: true });
  document.addEventListener("mouseleave", hide, true);
  window.addEventListener("scroll", hide, { passive: true });
})();

// 타이어 세트 그리드 필터 — 세션 토글 + 반납 추정 제외.
// 칩을 지우지 않고 흐리게만 한다(칸을 비우면 세로 정렬이 깨진다).
// 세션은 OR: 하나라도 켜져 있으면 "그중 하나라도 쓴 세트"만 남는다.
(() => {
  const apply = (bar) => {
    const grid = bar.parentElement.querySelector(".tsg");
    if (!grid) return;
    const sess = [...bar.querySelectorAll("[data-tsf].on")].map((b) => b.dataset.tsf);
    const noRet = !!bar.querySelector("[data-tsf-ret].on");
    grid.querySelectorAll(".tsg-row").forEach((row) => {
      let hit = 0;
      row.querySelectorAll(".tsg-set").forEach((set) => {
        const used = (set.dataset.s || "").split(" ").filter(Boolean);
        let ok = !sess.length || sess.some((s) => used.includes(s));
        if (noRet && set.classList.contains("is-ret")) ok = false;
        set.classList.toggle("dim", !ok);
        if (ok) hit++;
      });
      // 아무것도 안 남은 드라이버는 행째로 눌러 둔다 — 세로로 훑을 때 대상이 좁혀진다
      row.classList.toggle("dim", (sess.length > 0 || noRet) && hit === 0);
    });
  };

  document.addEventListener("click", (e) => {
    const btn = e.target.closest("[data-tsf-bar] button");
    if (!btn) return;
    const bar = btn.closest("[data-tsf-bar]");
    // 세션 칩은 한 번에 하나만. 여럿 켜두면 'FP1 또는 결승에 쓴 세트'가 되어
    // 무엇을 보고 있는지가 흐려진다 — 누른 걸 다시 누르면 전체로 돌아간다.
    // 반납 제외는 성격이 반대인 토글(빼는 필터)이라 따로 논다.
    if (btn.hasAttribute("data-tsf")) {
      const was = btn.classList.contains("on");
      bar.querySelectorAll("[data-tsf]").forEach((b) => b.classList.remove("on"));
      btn.classList.toggle("on", !was);
    } else {
      btn.classList.toggle("on");
    }
    apply(bar);
  });
})();

// 필터 복원은 맨 끝에서 — 버튼을 눌러 처리하는 방식이라 그 클릭을 받을 핸들러가
// 모두 등록된 뒤여야 한다. 위쪽(탭 복원 자리)에서 부르면 아무 일도 일어나지 않는다.
applyFiltersFromHash();
